<template>
    <h1 class="title-forgot"
        :style="{
            color: colors.theme !== 'dark' ? '#000' : '#fff',
        }"
    >{{title}}</h1>
</template>
<script>
export default {
    props: {
        title : {
            type : String,
            required : true
        }
    },

    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    }
}
</script>
<style lang="scss" scoped>
    .title-forgot{
        font-weight: 100;
        font-size: 15px;
        text-align: center;
        padding: 10% 0 5% 0;
    }
</style>
